import { useDispatch, useSelector } from 'react-redux';

import { OperatorField } from './OperatorField';
import { OperatorsActions } from '../../store/reducers/operators';
import Select from '../common/Select';
import {
  CARRIER_DHL,
  CARRIER_FEDEX,
  CARRIER_NONE,
  CARRIER_UPS,
  CARRIER_USPS,
  CarrierDisplayName,
} from '../../constants/carrierTypes';
import Input from '../blocks/Input/Input';

const carrierOptions = [
  { label: CarrierDisplayName[CARRIER_NONE], value: CARRIER_NONE },
  { label: CarrierDisplayName[CARRIER_UPS], value: CARRIER_UPS },
  { label: CarrierDisplayName[CARRIER_USPS], value: CARRIER_USPS },
  { label: CarrierDisplayName[CARRIER_DHL], value: CARRIER_DHL },
  { label: CarrierDisplayName[CARRIER_FEDEX], value: CARRIER_FEDEX },
];

export function OperatorCarrier() {
  const dispatch = useDispatch();
  const {
    configuration: { carrier },
  } = useSelector((state) => state.operators);

  const updateCarrier = (payload) => {
    dispatch({ type: OperatorsActions.configuration, payload: { carrier: { ...carrier, ...payload } } });
  };

  return (
    <OperatorField
      title="Carrier Account"
      description="If the operator is covering shipping costs, please specify the carrier and shipping account the vendor should use for order fulfillment."
    >
      <Select
        name="carrier"
        value={carrier?.carrier}
        onChange={(value) => updateCarrier({ carrier: value })}
        options={carrierOptions}
      />
      <Input
        onChange={(e) => updateCarrier({ account: e.target.value })}
        onFocus={(e) => e.target.select()}
        onClick={(e) => e.target.select()}
        value={!carrier || carrier.carrier === CARRIER_NONE ? '' : carrier?.account}
        disabled={!carrier || carrier.carrier === CARRIER_NONE}
      />
    </OperatorField>
  );
}
